var exports = {
  "W": "ParentIssueTokenContainer__SUNkH6",
  "w": "ParentIssueTokenMain__wtF-MH",
};

module.exports = exports;
